module.exports = __webpack_public_path__ + "odinstatic/v6.4.0/media/third-party.b1d223cb.svg";